import { alpha } from "@mui/material/styles";

export const typographyRecipes = {
  a11yHeaderLink: (theme) => ({
    color: alpha(theme.palette.common.white, 0.75),
    fontSize: "0.75rem",
    fontWeight: theme.typography.fontWeightMedium,
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: theme.palette.common.white,
    },
  }),
  filterLabel: (theme) => ({
    display: "block",
    marginBottom: theme.spacing(1.5),
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightMedium,
  }),
};

const textStyle = (theme, fontSize, fontWeight, lineHeight) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize,
  fontWeight,
  lineHeight,
});

// Registered as MuiTypography variants via toMuiVariants (theme/components/dataDisplay.js).
export const typographyRecipe = {
  intents: {
    price: ({ theme }) => textStyle(theme, "0.75rem", 700, "1rem"),
    priceStrike: ({ theme }) => ({ ...textStyle(theme, "0.625rem", 400, "0.875rem"), textDecoration: "line-through" }),
    priceLarge: ({ theme }) => textStyle(theme, "1.75rem", 700, "2.375rem"),
    priceStrikeLarge: ({ theme }) => ({ ...textStyle(theme, "1rem", 400, "1.375rem"), textDecoration: "line-through" }),
    agriCardTitle: ({ theme }) => textStyle(theme, "0.875rem", 600, "1.25rem"),
    agriCardDesc: ({ theme }) => textStyle(theme, "0.625rem", 500, "0.9375rem"),
    agriCardPack: ({ theme }) => textStyle(theme, "0.75rem", 500, "1rem"),
    metaKey: ({ theme }) => textStyle(theme, "0.75rem", 400, 1.5),
    metaValue: ({ theme }) => textStyle(theme, "0.75rem", 500, 1.5),
    statValue: ({ theme }) => textStyle(theme, "0.875rem", 700, "1.25rem"),
    sourceNote: ({ theme }) => textStyle(theme, "0.875rem", 600, "1.25rem"),
    helpCardTitle: ({ theme }) => textStyle(theme, "1.25rem", 600, "1.875rem"),
    helpCardBody: ({ theme }) => textStyle(theme, "1rem", 400, "1.5rem"),
    callCentreTitle: ({ theme }) => textStyle(theme, "1rem", 700, "1.5rem"),
    callCentreMeta: ({ theme }) => textStyle(theme, "0.75rem", 500, "1.125rem"),
    directoryCardTitle: ({ theme }) => textStyle(theme, "1.5rem", 600, "2rem"),
    directoryFieldKey: ({ theme }) => ({
      ...textStyle(theme, "0.75rem", 500, "1rem"),
      letterSpacing: "0.0375rem",
      textTransform: "uppercase",
    }),
    emptyStateTitle: ({ theme }) => textStyle(theme, "0.875rem", 700, "1.25rem"),
    emptyStateCardTitle: ({ theme }) => textStyle(theme, "1.25rem", 600, "1.875rem"),
    emptyStateCardDesc: ({ theme }) => textStyle(theme, "1rem", 500, "1.5rem"),
    emptyStateDesc: ({ theme }) => textStyle(theme, "0.75rem", 400, "1.125rem"),
    weatherAlertLabel: ({ theme }) => ({
      ...textStyle(theme, "0.5625rem", 600, 1),
      letterSpacing: "0.045rem",
      textTransform: "uppercase",
    }),
    weatherAlertTitle: ({ theme }) => textStyle(theme, "0.8125rem", 600, "1.05625rem"),
    weatherAlertDesc: ({ theme }) => textStyle(theme, "0.65625rem", 400, "0.984375rem"),
    weatherHeroTemp: ({ theme }) => textStyle(theme, "4.5rem", 800, 1.15),
    confirmDialogTitle: ({ theme }) => textStyle(theme, "1.25rem", 600, 1.5),
    confirmDialogDesc: ({ theme }) => textStyle(theme, "0.875rem", 400, 1.5),
    confirmDialogDetail: ({ theme }) => textStyle(theme, "0.875rem", 500, 1.5),
  },
};
